// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".warningTodayIssues{background-color:#f7f7fc;padding:1%;margin-top:1%;font-size:smaller;line-height:150%}.setSearchTextPosition{font-size:smaller;padding-top:-1%}.setResetBtnPosition{margin-right:82%!important}.hereClickStyle{cursor:pointer;color:#0d3cbf;text-decoration:underline;font-weight:700}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
